import { Component, computed } from '@angular/core';
import {
  ACTION_DATA_TEMPLATE,
  ActionComponent,
} from '@kinet-open-network/client/automations/feature/builder';
import {
  checkbox,
  DynamicFormField,
  formBuilder,
} from '@kinet-open-network/client/core/forms/ui';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'kon-write-order-to-onix-action',
  imports: [FormlyModule],
  template: ACTION_DATA_TEMPLATE,
})
export class WriteOrderToOnixActionComponent extends ActionComponent<'write-order-to-onix'> {
  override fields = computed<DynamicFormField[]>(() =>
    formBuilder([checkbox('disableAddresses', 'Nezapisovať adresy do ONIX')]),
  );
}
